module.exports = __webpack_public_path__ + "img/fwtx.abbdc474.png";